import { Logger } from '@oneappexchange/lwc-wired';
import { IS_DEVELOPMENT, LOGGER_WSS_ENDPOINT } from '../../config';

// extend error fn to allow sending any number of args as a JSON oject
class PublishingLogger extends Logger {
  error(...args) {
    if (args.length > 1) {
      if (typeof args[0] === 'string') {
        super.error(JSON.stringify({
          message: args[0],
          data: args.length === 2 ? args[1] : args.slice(1)
        }));
      } else {
        super.error(JSON.stringify({
          data: args
        }));
      }
    } else {
      super.error(args[0]);
    }
  }
  /*LWC compiler v7.1.3*/
}
export const logger = new PublishingLogger({
  wssEndpoint: LOGGER_WSS_ENDPOINT || '',
  prefix: '[Appx-PubUI]: ',
  source: 'publishing-ui',
  developmentMode: IS_DEVELOPMENT
});